import React, { FC } from "react";
import { useHistory } from "react-router-dom";

import Button from "../../../../components/elements/Button";
import classes from "./Controls.module.scss";

type ControlsProps = {
  handleGetStarted: () => void;
};

const Controls: FC<ControlsProps> = ({ handleGetStarted }) => {
  const history = useHistory();

  const handleBack = () => history.push("/dashboard");

  return (
    <div className={classes.container}>
      <Button variant="outlined" onClick={handleBack}>
        Back
      </Button>
      <Button variant="contained" onClick={handleGetStarted}>
        Get Started
      </Button>
    </div>
  );
};

export default Controls;
